export default __webpack_public_path__ + "static/media/discovery.58d7e362.png";